import FullParagraphDefaultProps from "segments/desktop/core-components/full-paragraph/default-props";
import { positionTypes } from "segments/desktop/core-components/images-grid/images-grid-service";
import { MD } from "constants/sizes";
export default {
    images: [
        {
            src: "/static/img/segment-layout-default-images/grid/man-with-blue-shirt.png",
            fullParagraph: FullParagraphDefaultProps
        },
        {
            src: "/static/img/segment-layout-default-images/grid/woman-with-sunglasses-and-orange-shirt.png",
            fullParagraph: FullParagraphDefaultProps
        },
        {
            src: "/static/img/segment-layout-default-images/grid/man-with-hat-and-sunglasses.png",
            fullParagraph: FullParagraphDefaultProps
        },
        {
            src: "/static/img/segment-layout-default-images/grid/woman-with-sunglasses-in-the-wind.png",
            fullParagraph: FullParagraphDefaultProps
        }
    ],
    paddingTop: "56px",
    paddingBottom: "56px",
    imagePosition: positionTypes.CENTER_CENTER,
    textAlign: "left",
    titleSize: MD,
    textSize: MD,
    autoHeight: false
};
